import { render, staticRenderFns } from "./contract-card.vue?vue&type=template&id=51d67481&scoped=true"
import script from "./contract-card.vue?vue&type=script&lang=js"
export * from "./contract-card.vue?vue&type=script&lang=js"
import style0 from "./contract-card.vue?vue&type=style&index=0&id=51d67481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d67481",
  null
  
)

export default component.exports